import React from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@mui/styles';
import AppAnimate from "../../../../components/AppAnimate";
import {useTranslation} from "react-i18next";
import Title from "../../../../components/elements/Title";
import Stocks from "./Stocks";
import MyStocks from "./MyStocks";


function StocksPage({manage}){
    const { t } = useTranslation();

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={manage ? t('manageStocks') : t('myStocks')}>
            <Grid container spacing={2} justify="center">
                <Grid item size={12}>
                    <Title align="left" color="text" className="panel-title">{manage ? t('manageStocks') : t('myStocks')}</Title>
                    {
                        manage ?
                            <Stocks/>
                            :
                            <MyStocks/>
                    }

                </Grid>
            </Grid>
        </AppAnimate>
    );
}
export default withStyles(Styles)(StocksPage);
